import {Card, Col, Image, Row} from "react-bootstrap";
import React from "react";

import styles from './UserAccessPage.module.scss';

type Props = {
    children: React.ReactNode;
};

const UserAccessPage = ({children}: Props) => {

    return (
        <Col xs={12} md={{span: 11, offset: 1}} lg={{span: 6, offset: 3}} className={styles.UserAccessPage}>
            <Row className={'mt-3 mt-md-5 mb-4'}>
                <Col xs={6} className={'me-auto ms-auto'}>
                    <Image src={'/images/Consent-On-Demand-logo-CMYK-300.jpg'}
                           alt={'Consent on Demand Logo'}
                           fluid
                           className={'w-100 me-auto ms-auto'}/>
                </Col>
            </Row>
            <Row className={'justify-content-center'}>
                <Col xs={10} md={10}>
                    <Card className={'rounded-card'}>
                        <Card.Body>
                            {children}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Col>
    );
};

export default UserAccessPage;
